import { useAuth } from "@/lib/auth";
import { UserCircle, Building2, Shield } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div data-testid="settings-page" className="max-w-3xl">
      <div className="kicker mb-2">Account</div>
      <h1 className="text-4xl font-display mb-8">Settings</h1>

      <div className="space-y-6">
        <section className="grid-panel p-6">
          <div className="flex items-center gap-2 mb-4">
            <UserCircle size={16} className="text-brass" />
            <div className="kicker">Broker Profile</div>
          </div>
          <Row label="Name" value={user?.full_name} />
          <Row label="Email" value={user?.email} />
          <Row label="Brokerage" value={user?.brokerage_name || "—"} />
          <Row label="License Number" value={user?.license_number || "—"} />
          <Row label="Role" value={user?.role || "broker"} last />
        </section>

        <section className="grid-panel p-6">
          <div className="flex items-center gap-2 mb-4">
            <Shield size={16} className="text-brass" />
            <div className="kicker">Compliance Notice</div>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed">
            OfferForge CRE generated drafts are business terms only. Nothing produced by this
            application constitutes a title commitment, legal opinion, survey, appraisal,
            zoning determination, environmental report, or guaranteed legal fact. Every
            transaction is subject to broker, client, title, lender, tax, and legal review.
          </p>
        </section>

        <section className="grid-panel p-6">
          <div className="flex items-center gap-2 mb-4">
            <Building2 size={16} className="text-brass" />
            <div className="kicker">Data Sources</div>
          </div>
          <p className="text-sm text-slate-600 mb-3">Public-record connectors used for research:</p>
          <ul className="text-sm text-slate-700 space-y-1 list-disc list-inside">
            <li>County Assessor & Recorder Portals (jurisdiction-specific)</li>
            <li>Municipal Zoning & GIS Systems</li>
            <li>FEMA Flood Maps · EPA Environmental Records</li>
            <li>Commercial Listing Platforms (broker-uploaded)</li>
            <li>State Corporate Registries</li>
          </ul>
          <p className="text-xs text-slate-500 mt-3">
            Every researched fact requires broker confirmation before it is used in a final offer document.
          </p>
        </section>
      </div>
    </div>
  );
}

function Row({ label, value, last }) {
  return (
    <div className={`flex items-center justify-between py-2 ${!last ? "border-b border-border" : ""}`}>
      <div className="text-sm text-slate-500 uppercase tracking-widest text-xs">{label}</div>
      <div className="text-sm text-navy font-medium">{value}</div>
    </div>
  );
}
